import Spinner from "@/components/Spinner";
import { useState } from "react";
import { endpoints } from "../../../hooks/endpoints";
import { getToken } from "../../../hooks/utils";
import { useAppDispatch } from "../../../store/hooks";
import { pushModal } from "../../../store/slices/modalsSlice";
import GeneralMessageModal from "../../Modals/GeneralMessageModal";

const FawryPurchase = ({
  lesson_id,
  amount,
}: {
  lesson_id: number;
  amount?: number;
}) => {
  const [data, setData] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useAppDispatch();

  const handlePurchase = () => {
    if (Number(amount) < 50)
      return dispatch(
        pushModal(
          <GeneralMessageModal msg="أقل قيمة للشحن هي 50 جنيه" btnMsg="حسنا" />
        )
      );
    if (Number(amount) > 10000)
      return dispatch(
        pushModal(
          <GeneralMessageModal
            msg="أقصى قيمة للشحن هي 10,000 جنيه"
            btnMsg="حسنا"
          />
        )
      );

    setError(null);
    setIsPending(true);
    fetch(endpoints.fawaterakPurchase, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
      },
      body: JSON.stringify({
        product_id: lesson_id,
        payment_method: 3,
        amount,
      }),
      // signal: abortCont.signal
    })
      .then((response) => response.json())
      .then((result) => {
        console.log("this is result: ", result);
        setData(result);
        setIsPending(false);
      })
      .catch((err) => {
        console.log(err);
        setError("حدث خطأ");
        setIsPending(false);
      });
  };

  return (
    <div className="block">
      {!isPending && (
        <button
          onClick={handlePurchase}
          className="block mx-auto px-6 py-2 bg-primary text-white font-bold rounded-lg hover:bg-primary/90 transition"
        >
          طلب كود الدفع
        </button>
      )}

      {isPending && (
        <button
          type="button"
          disabled
          className="gap-2 mx-auto px-6 py-2 bg-primary text-white font-bold rounded-lg flex items-center cursor-not-allowed"
        >
          <Spinner variant="button" />
          طلب كود الدفع...
        </button>
      )}

      {data && (
        <div className="flex">
          <div
            role="alert"
            className="mx-auto my-2 px-4 py-3 rounded-lg bg-green-100 border border-green-400 text-green-800 w-full md:w-auto"
          >
            <p>كود فوري : {data.fawryCode}</p>
            <p>تاريخ إنتهاء صلاحية الكود : {data.expireDate}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default FawryPurchase;
